const base =
  'inline-block py-4 px-9 rounded-sm font-sans text-[13px] font-medium uppercase tracking-[0.08em] bg-clay text-white hover:bg-clay-dark hover:-translate-y-px transition-all duration-200';

export default function BtnPrimary({ href, onClick, children, className = '', type = 'button', disabled }) {
  if (href) {
    return (
      <a href={href} className={`${base} ${className}`}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={`${base} ${className}`} disabled={disabled}>
      {children}
    </button>
  );
}
